// Module
var code = `<div class="js-types-ManagerScreen-footerBtn">
    <terceraButton name="ok"
                   text="{{.okBtnText}}"
                   tooltip="{{.okBtnTooltip}}"
                   enabled="{{.enabledBtn}}"
                   terceraButtonStyle="js-button-ok style-width-100"
                   on-btnClick="@this.okClick()" />

    <terceraButton name="cancel"
                   text="{{.cancelBtnText}}"
                   tooltip="{{.cancelBtnTooltip}}"
                   terceraButtonStyle="js-button-gray25 style-width-100"
                   on-btnClick="@this.onCloseButtonClick()" />
</div>`;
// Exports
export default code;